<template>
  <div class="Warp">
    <van-grid :column-num="4" :border="false">
      <van-grid-item text="消费者名称" />
      <van-grid-item text="卡券名称" />
      <van-grid-item text="使用商户" />
      <van-grid-item text="使用时间" />
    </van-grid>
    <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="uploader"
      >
        <div
          v-for="item in statement_get_list"
          :key="item.id"
          @click="toDetail(item)"
        >
          <van-grid :column-num="4" :border="false">
            <van-grid-item :text="item.name"> </van-grid-item>
            <van-grid-item :text="item.title" />
            <van-grid-item :text="item.card_type == 'FULL_REDUCE' ? '满减' : '折扣'"/>
            <van-grid-item>
              <div class="van_grid_item">{{ item.date }}</div>
              <div class="van_grid_item">{{ item.time }}</div>
            </van-grid-item>
          </van-grid>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      limit: 10,
      statement_get_list: [],
      loading: false,
      refreshLoading: false,
      finished: false,
    };
  },
  mounted() {
    this.getstatementUseList();
  },
  methods: {
    getstatementUseList() {
      var reqData = {
        page: this.page,
        limit: this.limit,
      };
      this.$http
        .get("/wechat/api.coupon/consumerCouponPay", { params: reqData })
        .then((res1) => {
          var res = res1.body;
          console.log(res);
          res.data.rows.map((v) => {
               let data_time = v.use_time.split(" ");
            v.date = data_time[0];
            v.time = data_time[1];
            this.statement_get_list.push(v);
          });
          this.loading = false;
          this.refreshLoading = false;
          if (this.statement_get_list.length >= res.data.count) {
            this.finished = true;
          }
        });
    },
    toDetail(item){
        this.$router.push({
            path:'/statement_use_detail',
            query:item
        })
    },
    onRefresh(){
        this.page=1;
        this.statement_get_list=[];
        this.finished=false;
        this.getstatementUseList();
    },
    uploader(){
        this.page++;
        this.getstatementUseList();
    }
  },
};
</script>
<style lang="less" scoped>
.van_grid_item {
  color: #646566;
  font-size: 0.32rem;
  line-height: 1.5;
  word-break: break-all;
}
</style>